import { render, staticRenderFns } from "./UserRoleTable.vue?vue&type=template&id=58b908d7"
import script from "./UserRoleTable.vue?vue&type=script&lang=js"
export * from "./UserRoleTable.vue?vue&type=script&lang=js"
import style0 from "./UserRoleTable.vue?vue&type=style&index=0&id=58b908d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports